import { Badge, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { TimetableDraggableItemsRowProps } from '@modules/timetable';
import { useMst } from '@models/Root';
import { TimelineItemTypeType } from '@app-types/timetable';
import { HSMSDraggableItem } from '@components/shared';
import { SubjectSlotContainer } from './SubjectBlocks';

export const TimetableDraggableItem = observer(
  ({ id, hoursPerSlot, totalSlots, slotName, slotCode, slotColor, type }: TimetableDraggableItemsRowProps) => {
    const { setSelectedDraggableItem, selectedLecturer } = useMst().timetable;

    return (
      <Tooltip mouseLeaveDelay={0.01} title={slotName}>
        <SubjectSlotContainer
          onClick={() => {
            setSelectedDraggableItem(`${type}/${id}`);
          }}
        >
          <Badge count={totalSlots} className="site-badge" showZero />
          <HSMSDraggableItem
            id={id}
            draggableType="subject"
            duration={hoursPerSlot}
            title={slotName}
            color={slotColor}
            elementID={id}
            lecturerID={selectedLecturer}
            itemType={type === 'subject' ? TimelineItemTypeType.subject : TimelineItemTypeType.extra}
            useMst={useMst}
            subjectName={slotName}
          >
            <span className="name-tag">{slotCode}</span>
          </HSMSDraggableItem>
        </SubjectSlotContainer>
      </Tooltip>
    );
  },
);
